export default {
    init() {
    
        // JavaScript to be fired on all page
        $(".liquid").imgLiquid();

        $('#open').click(function() {
            $('#overlay').addClass('open');
            $("body").addClass("nav-open");
        });

        $('#close').click(function() {
            $('#overlay').removeClass('open');
            $("body").removeClass("nav-open");
        });

        $('.open-boek').click(function(e) {
            e.preventDefault();
            $('.modal_overlay').velocity('fadeIn');
             $("body").addClass("modal-open");
            var file = $('.modal_overlay').attr('data-url');
            $('input[name="pdf-url-sheet"]').val(file);
        });

        if(window.location.hash == '#download-ebook') {
            $('.modal_overlay').velocity('fadeIn');
            $("body").addClass("modal-open");
            var file = $('.modal_overlay').attr('data-url');
            $('input[name="pdf-url-sheet"]').val(file);
        }

        $('.modal_overlay .fa-times').click(function() {
            $('.modal_overlay').velocity('fadeOut');
            $("body").removeClass("modal-open")
        });

        $('.modal_leave .fa-times').click(function() {
            $('.modal_leave').velocity('fadeOut');
            $("body").removeClass("modal-open")
        });

        var triggered = false;
        var inWindow = false;

        $(window).on("mousemove", function (e) {

            if(e.pageY > 100) {
                inWindow = true;
            }

            if (e.pageY - $(window).scrollTop() < 5 && !triggered && localStorage.getItem('leave_popup') !== 'opened' && inWindow == true) {
                triggered = true;

                if($(this).outerWidth() > 760){
                    localStorage.setItem('leave_popup', 'opened');
                    $('.modal_leave').velocity('fadeIn');
                    $("body").addClass("modal-open");
                }
            }

        });

        $("#search_button").click(function() {
            $('.navbar .search-box').fadeToggle("fase", function() {
                if ($(this).is(':visible'))
                    $(this).css('display', 'inline-block');
            });
            // $(".navbar .search-box").fadeToggle();
            $("#search_button .fa").toggleClass("fa-times fa-search");
        });

        $('.matchHeight').matchHeight();
        $('.matchHeightItems').matchHeight({ byRow: false });

        if (!Modernizr.cssanimations) {
            $('.overlay ul li').css({opacity: 1})
        }

        var scrollTimeout;
        var throttle = 0;

        $(window).on('scroll', function () {
            if (!scrollTimeout) {
                scrollTimeout = setTimeout(function () {
                    var st = $(this).scrollTop();

                    if(st > 10) {
                        $('.navbar ').addClass('scroll');
                    } else {
                        $('.navbar ').removeClass('scroll');
                    } 

                    scrollTimeout = null;
                }, throttle);
            }
        });

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js